import {  Trans  } from "@/client/libs/dummy-i18n";
import { sortByDate } from "@stackmorph/utils";
import { AnimatePresence, motion } from "framer-motion";

import { useResumes } from "@/client/services/resume";

import { BaseCard } from "./_components/base-card";
import { ResumeCard } from "./_components/resume-card";

export const GridView = () => {
  const { resumes, loading } = useResumes();

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {loading &&
        Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="duration-300 animate-in fade-in"
            style={{ animationFillMode: "backwards", animationDelay: `${i * 100}ms` }}
          >
            <BaseCard />
          </div>
        ))}

      {Array.isArray(resumes) && resumes.length === 0 && !loading && (
        <div className="col-span-full flex flex-col items-center justify-center py-20 text-center">
          <div className="mb-4 text-6xl" role="img" aria-label="Document icon">
            📄
          </div>
          <h3 className="text-lg font-semibold"><Trans>No resumes yet</Trans></h3>
          <p className="mt-1 text-sm text-muted-foreground">
            <Trans>Click the + button to create your first resume</Trans>
          </p>
        </div>
      )}

      {Array.isArray(resumes) && (
        <AnimatePresence>
          {resumes
            .sort((a, b) => sortByDate(a, b, "updatedAt"))
            .map((resume, index) => (
              <motion.div
                key={resume.id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1, transition: { delay: index * 0.05 } }}
                exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
              >
                <ResumeCard resume={resume} />
              </motion.div>
            ))}
        </AnimatePresence>
      )}
    </div>
  );
};
